/* eslint-disable no-irregular-whitespace */
export const REGEX_FORMATS = {
  MENTION_USER: /@\[(.*?)]\(data:(.*?)\)/g, // regex to match a username
  BREAK_LINE: /\n/g, // regex to match \n
  SYMBOLS: /[a-zA-Z0-9`~!@#$%^&*()\-_+={}[/:";'<>.?\]]/,
  KATAKANA: /[Ａ-Ｚァ-ン０-９－，：；（）ー　]/,
}
